import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="pt-16 pb-20 px-6 md:px-12 max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12" data-id="element-82">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="flex-1 text-center lg:text-left" data-id="element-83">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-charcoal leading-tight mb-6" data-id="element-84">
          El "Interruptor Hormonal" para Mujeres de 40+:{' '}
          <span className="text-coral" data-id="element-85">
            Recupera tu Cintura y tu Energía en 21 Días
          </span>{' '}
          <span className="text-2xl md:text-3xl block mt-2 font-normal text-sage" data-id="element-86">
            (Sin Dietas de Hambre)
          </span>
        </h1>
        <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-87">
          El protocolo de Nutrición Circadiana diseñado para la mujer latina en
          USA que siente que "el aire la engorda" debido al cambio metabólico de
          los 40.
        </p>
        <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-88">
          ¡QUIERO MI RESET METABÓLICO AHORA!
        </Button>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="flex-1 w-full max-w-md lg:max-w-full" data-id="element-89">
        <img src="https://cdn.magicpatterns.com/uploads/211J7vB1UNauhNfhsTaXSG/Metabolismo_402B_Reset.png" alt="Metabolismo 40+ Reset en iPad" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-90" />
      </motion.div>
    </section>;
}